const NOTE_ROUTE_PATTERN = /^\/n\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/?$/i
const ADMIN_ROUTE_PATTERN = /^\/admin(?:\/|$)/i

interface RouteHistory {
  readonly state: unknown
  replaceState(data: unknown, unused: string, url?: string | URL | null): void
}

interface GuardHistory extends RouteHistory {
  pushState(data: unknown, unused: string, url?: string | URL | null): void
}

function currentHistory(): RouteHistory {
  return window.history
}

export function readNoteRoute(pathname = window.location.pathname): string | null {
  return NOTE_ROUTE_PATTERN.exec(pathname)?.[1]?.toLowerCase() ?? null
}

/** The Links screen (links/library/): one address, no ids. */
export function readLinksRoute(pathname = window.location.pathname): boolean {
  return /^\/links\/?$/.test(pathname)
}
export function replaceLinksRoute(history: RouteHistory = currentHistory()): void {
  history.replaceState(history.state, '', '/links')
}
export function readAdminRoute(pathname = window.location.pathname): boolean {
  return ADMIN_ROUTE_PATTERN.test(pathname)
}

export function adminPath(): string {
  return '/admin'
}

export function notePath(noteId: string): string {
  return `/n/${noteId.toLowerCase()}`
}

export function replaceNoteRoute(
  noteId: string,
  history: RouteHistory = currentHistory(),
): void {
  history.replaceState(history.state, '', notePath(noteId))
}

export function clearNoteRoute(history: RouteHistory = currentHistory()): void {
  history.replaceState(history.state, '', '/')
}

export function pushGuardedRouteEntry(
  baseState: unknown,
  guardState: unknown,
  history: GuardHistory = window.history,
  pathname = window.location.pathname,
  search = typeof window === 'undefined' ? '' : window.location.search,
): void {
  const routeNoteId = readNoteRoute(pathname)
  const guardedPath = routeNoteId
    ? notePath(routeNoteId)
    : readLinksRoute(pathname)
      ? '/links'
    : readAdminRoute(pathname)
      ? pathname + search
      : null
  if (!guardedPath) {
    history.pushState(guardState, '')
    return
  }
  history.replaceState(baseState, '', '/')
  history.pushState(guardState, '', guardedPath)
}
